export var TrainingSessionHappinessEnum;
(function (TrainingSessionHappinessEnum) {
    TrainingSessionHappinessEnum["worse"] = "worse";
    TrainingSessionHappinessEnum["bad"] = "bad";
    TrainingSessionHappinessEnum["medium"] = "medium";
    TrainingSessionHappinessEnum["good"] = "good";
    TrainingSessionHappinessEnum["very_good"] = "very_good";
})(TrainingSessionHappinessEnum || (TrainingSessionHappinessEnum = {}));
//# sourceMappingURL=training-session-happiness.enum.js.map